module.exports = __webpack_public_path__ + "img/sword-flame.0632e6f6.svg";